/**
 * HomeIndicator — iOS home-indicator safe-area spacer.
 *
 * Per `DESIGN.md §13`: occupies the bottom edge on mobile so content does
 * not sit under the system gesture area.
 */
export function HomeIndicator() {
  return (
    <div
      data-component="HomeIndicator"
      className="fixed inset-x-0 bottom-0 z-30 h-[env(safe-area-inset-bottom)] pointer-events-none"
      aria-hidden
    />
  );
}
